<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <div style="position:fixed; right: 20px; top: 120px; z-index: 3;">
                <!--Bookmark Dialog-->
                    <v-dialog v-model="dialogBookmark" width="1200">
                        <template v-slot:activator="{on, attrs}">
                            <v-btn color="#059DC0" v-bind="attrs" v-on="on" large fab elevation="3" :loading="cartloading"><v-icon color="white">mdi-bookmark-multiple</v-icon></v-btn>
                        </template>
                        <v-card>
                            <v-toolbar elevation="0" color="#059DC0" dark>
                                <v-toolbar-title><v-icon>mdi-bookmark-multiple</v-icon>&nbsp;Bookmark</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="closeDialogBookmark">
                                    <v-icon>mdi-close-thick</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-card elevation="0">
                                    <v-card-text>
                                        <Bookmark v-if="dialogBookmark" />
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                <!--End of Bookmark Dialog-->
                </div>
            </v-card-text>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="applications"
                    :loading="tableloading"
                    loading-text="Calling Application data..."
                    :search="search"
                    sort-by="submittedTimestamp"
                    sort-desc="true"
                >
                    <!--group-by="applicationid"-->
                    <template v-slot:top>
                        <v-row align="center">
                            <v-col cols="6">
                                <span v-if="departmentPermissions.length == 2" class="text-h6">Applications for Department <b>{{ departmentPermissions[1] }}</b></span>
                                <v-select 
                                    :items="departmentPermissions" label="Filter by Department" v-model="departmentfilter" hide-details
                                    outlined dense @change="filterByDepartment" v-else
                                ></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Search" hide-details dense outlined>
                                    <template v-slot:append-outer>
                                        <v-btn icon small outlined @click="filterByDepartment"><v-icon>mdi-refresh</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <!--
                    <template v-slot:group.header="{ items }">
                        <th colspan="10" style="background-color: #EEEDE7;">
                            <span>Application by {{ items[0].name }}</span>
                        </th>
                    </template>
                    -->
                    <template v-slot:item.bookmark="{ item }">
                        <v-btn :loading="bookmarkloading" class="mr-2" v-if="item.inbookmark" icon>
                            <v-icon>
                                mdi-bookmark
                            </v-icon>
                        </v-btn>
                        <v-btn :loading="bookmarkloading" class="mr-2" @click="bookmarkApplication(item)" icon v-else>
                            <v-icon>
                                mdi-bookmark-outline
                            </v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.adoflag="{ item }">
                        <v-icon class="mr-2" v-if="item.adoFlag == 1" color="#FB4570">
                            mdi-flag
                        </v-icon>
                        <v-icon class="mr-2" v-else>
                            mdi-flag-outline
                        </v-icon>
                    </template>
                    <template v-slot:item.hrflag="{ item }" v-if="permissions.setHRflag">
                        <v-tooltip bottom v-if="checkHRFlagging(item['generalinfo']['id']) == 1">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="#FB4570"  v-bind="attrs" v-on="on">mdi-flag-variant</v-icon>
                            </template>
                            <span>{{ typeof(flaggingList.find(v=> v.id == item['generalinfo']['id'] && v.type == 'setHRflag')) != 'undefined' ? flaggingList.find(v=> v.id == item['generalinfo']['id'] && v.type == 'setHRflag').comment : '' }}</span>
                        </v-tooltip>
                        <v-icon v-else>mdi-flag-variant-outline</v-icon>
                    </template>
                    <template v-slot:item.view="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="viewApplication(item)"
                        >
                            mdi-eye
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        <v-container style="height: 350px;">
                            <v-row
                                class="fill-height"
                                align-content="center"
                                justify="center"
                            >
                                <v-col
                                    class="text-subtitle-1 text-center"
                                    cols="12"
                                >
                                    No Applications
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="dialog"
            fullscreen
            persistent
        >
            <v-card elevation="0">
                <v-toolbar color="#7CB342" dark>
                    <v-toolbar-title>View Application for {{ selectedApplication.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeView">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <ViewDetails :item="selectedApplication" v-if="dialog"/>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewDetails from "./ViewDetails.vue"
import Bookmark from "./Bookmark.vue"

import auth from '@/js/auth'
export default {
    components: {
        ViewDetails,
        Bookmark
    },
    data(){
        return {
            departmentPermissions: [],
            host: location.hostname.toString(),
            bookmarkList: [],
            tableloading: true,
            search: '',
            departmentfilter: 'All',
            headers: [
                { text: '', value: 'bookmark', sortable: false, groupable: false },
                { text: 'ADO', value: 'adoflag', sortable: false, groupable: false },
                { text: 'Name', value: 'name', groupable: false},
                { text: 'Term', value: 'term', groupable: false },
                { text: 'Subject', value: 'discipline', groupable: false },
                { text: 'Posting Title', value: 'postingtitle', groupable: false },
                { text: 'type', value: 'postingtype', groupable: false },
                { text: 'Course(s)', value: 'coursesText', groupable: false},
                { text: 'Section(s)', value: 'sectionsText', groupable: false},
                { text: 'Submitted', value: 'submittedtime', groupable: false },
                { text: 'View', value: 'view', sortable: false, groupable: false },
            ],
            applications: [],
            selectedApplication: {},
            dialog: false,
            dialogBookmark: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            bookmarkloading: false,
            flaggingList: [],
            permissions: {}
        }
    },
    methods: {
        getPermissions(){
            const that = this;
            that.departmentPermissions = [];
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("allowedDepartments")){
                if(permission.allowedDepartments.length>0){
                    that.departmentPermissions.push("All");
                    permission.allowedDepartments.forEach(element => {
                        that.departmentPermissions.push(element);
                    });

                    if(that.departmentPermissions.length == 2){
                        that.departmentfilter = that.departmentPermissions[1];
                    }else { 
                        that.departmentfilter = "All";
                    }
                }else {
                    that.departmentPermissions = [];
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.getDepartmentList();
                that.departmentfilter = "All";
            }else {
                that.departmentPermissions = [];
            }

            if(permission.hasOwnProperty("setHRflag")){
                if(permission.setHRflag == 1){
                    that.permissions["setHRflag"] = true;
                }else {
                    that.permissions["setHRflag"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["setHRflag"] = true;
            }else {
                that.permissions["setHRflag"] = false;
            }

            let tableheaders = [
                { text: '', value: 'bookmark', sortable: false, groupable: false },
                { text: 'ADO', value: 'adoflag', sortable: false, groupable: false },
                { text: 'HR', value: 'hrflag', sortable: false, groupable: false },
                { text: 'Name', value: 'name', groupable: false},
                { text: 'Term', value: 'term', groupable: false },
                { text: 'Subject', value: 'discipline', groupable: false },
                { text: 'Posting Title', value: 'postingtitle', groupable: false },
                { text: 'type', value: 'postingtype', groupable: false },
                { text: 'Course(s)', value: 'coursesText', groupable: false},
                { text: 'Section(s)', value: 'sectionsText', groupable: false},
                { text: 'Submitted', value: 'submittedtime', groupable: false },
                { text: 'View', value: 'view', sortable: false, groupable: false },
            ]

            //Data table Header Settings
            if(that.permissions["setHRflag"] == false){
                that.headers = tableheaders.filter(v=> v.value != 'hrflag');
            }else {
                that.headers = tableheaders;
            }
        },
        getDepartmentList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getacademicdepartments';
            that.dataLoading = true;
            that.takenDisciplinelist = [];
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.departmentPermissions.push("All");
                            json.data.forEach(element => {
                                that.departmentPermissions.push(element["department"]);
                            });
                        }
                    }else {
                        that.departmentPermissions = [];
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        getBookmark(){
            const that = this;
            that.bookmarkList = [];
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getbookmarks';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            if(json.data[0].hasOwnProperty("bookmarks")){
                                json.data[0].bookmarks.forEach(element => {
                                    that.bookmarkList.push({"bookmarkid":element["_itemid"] ,"applicationid": element["applicationid"], "postingid": element["postingid"]});
                                });
                            }
                        }

                        that.filterByDepartment();
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        getApplicationList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getapplications';
            that.tableloading = true;
            that.applications = [];

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.flaggingList = json.flags;
                        that.modifyData(json.data);
                        that.setSnackbar("Calling applications successful!", "#388E3C"); //green
                        that.tableloading = false;
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        modifyData(items){
            const that = this;
            var list = [];
            items.forEach(element => {
                for(var i=0; i<element["postings"].length; i++){
                    let record = {};
                    record["applicationid"] = element["id"];
                    record["uid"] = element["uid"];
                    record["discipline"] = element["discipline"];
                    record["posting"] = element["postings"][i];
                    record["cupeposition"] = element["cupeposition"];
                    record["legaltowork"] = element["legaltowork"];
                    record["generalinfo"] = element["generalinfo"];
                    record["employment"] = element["employment"];
                    record["education"] = element["education"];
                    record["references"] = element["references"];
                    record["fileCV"] = element["fileCV"];
                    if(element.hasOwnProperty("suppletype1")){
                        record["filesupple1"] = element["filesupple1"];
                        record["suppletype1"] = element["suppletype1"];
                    }
                    if(element.hasOwnProperty("suppletype2")){
                        record["filesupple2"] = element["filesupple2"];
                        record["suppletype2"] = element["suppletype2"];
                    }
                    record["submittedTimestamp"] = element["submittedTimestamp"];
                    record["submitYear"] = element["submitYear"];
                
                    record["name"] = element["generalinfo"]["firstname"]+" "+element["generalinfo"]["lastname"];
                    record["submittedtime"] = that.convertTime(element["submittedTimestamp"]);
                    record["term"] = that.resolveTerm(element["postings"][0]["strm"]);
                    record["postingtitle"] = element["postings"][i]["title"];
                    record["postingid"] = element["postings"][i]["id"];
                    record["postingtype"] = element["postings"][i]["type"];
                    //Courses & Sections
                    var courselist = "";
                    var sectionlist = "";
                    element["postings"][i]["courses"].forEach(e => {
                        if(e["ssrcomponent"] == "LEC"){
                            courselist += e["catalognbr"]+", ";
                            sectionlist += e["classsection"]+", ";
                        }
                    });
                    record["coursesText"] = courselist.slice(0,-2);
                    record["sectionsText"] = sectionlist.slice(0,-2);

                    //bookmark
                    that.bookmarkList.forEach(bookmark => {
                        if(element["id"] == bookmark["applicationid"] && element["postings"][i]["id"] == bookmark["postingid"]){
                            record["bookmarkid"] = bookmark["bookmarkid"];
                            record["inbookmark"] = true;
                        }
                    });

                    // 2024 March Update - ADO flagging
                    record["adoFlag"] = that.checkFlagging(record["generalinfo"]["id"]);

                    //2025 March Update - HR flagging
                    if(that.permissions.setHRflag){
                        record["hrFlag"] = {
                            value: that.checkHRFlagging(record["generalinfo"]["id"]),
                            comment: typeof(that.flaggingList.find(v=> v.id == record["generalinfo"]["id"] && v.type == 'setHRflag')) != 'undefined' ? that.flaggingList.find(v=> v.id == record["generalinfo"]["id"] && v.type == 'setHRflag').comment : ''
                        }
                    }else {
                        record["hrFlag"] = "Not authorized"
                    }

                    if(element.hasOwnProperty("admin")){
                        /*  2024 March Update - ADO flagging now shown in a separate key
                            if(element["admin"].hasOwnProperty("adoFlag")){
                                record["adoFlag"] = parseInt(element["admin"]["adoFlag"]["value"]);
                            }else {
                                record["adoFlag"] = 0;
                            }
                        */
                        
                        if(element["admin"].hasOwnProperty("seniorityPoints")){
                            record["seniorityPoints"] = element["admin"]["seniorityPoints"]["value"];
                        }else {
                            record["seniorityPoints"] = "";
                        }

                        if(element["admin"].hasOwnProperty("justifications")){
                            var justifications = [];
                            element["admin"]["justifications"].forEach(comments => {
                                if(courselist.slice(0,-2) == comments["course"]){
                                    justifications.push({
                                        "comment": comments["comment"],
                                        "madeby": comments["updatedByCommonName"],
                                        "madeon": comments["updatedDateTime"].split(".")[0]
                                    })
                                }
                            });

                            record["justifications"] = justifications;
                        }else {
                            record["justifications"] = [];
                        }

                        if(element["admin"].hasOwnProperty("managerComments")){
                            var managercomments = [];
                            element["admin"]["managerComments"].forEach(comm => {
                                if(courselist.slice(0,-2) == comm["course"]){
                                    managercomments.push({
                                        "comment": comm["comment"],
                                        "madeby": comm["updatedByCommonName"],
                                        "madeon": comm["updatedDateTime"].split(".")[0]
                                    })
                                }
                            });

                            record["managercomments"] = managercomments;
                        }else {
                            record["managercomments"] = [];
                        }
                    }else {
                        record["justifications"] = [];
                        record["managercomments"] = [];
                    }

                    list.push(record);
                }
            });
            
            that.applications = list;
        },
        checkFlagging(id){
            const that = this;
            let value = 0;

            that.flaggingList.forEach(element => {
                if(element.id == id && element.type == 'setADOflag'){
                   value = element.value;
                }
            });

            return value
        },
        checkHRFlagging(id){
            const that = this;
            let value = 0;

            that.flaggingList.forEach(element => {
                if(element.id == id && element.type == 'setHRflag'){
                   value = element.value;
                }
            });

            return value
        },
        convertTime(time){
            let date = new Date(parseFloat(time));

            return date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        bookmarkApplication(item){
            const that = this;
            that.bookmarkloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=setBookmark&data={"applicationid": "'+item.applicationid+'", "postingid": "'+item.postingid+'"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.getBookmark();
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }
                    that.bookmarkloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.bookmarkloading = false;
                })
        },
        closeDialogBookmark(){
            const that = this;

            that.getBookmark();
            that.dialogBookmark = false;
        },
        viewApplication(item){
            const that = this;
            that.selectedApplication = item;
            that.dialog = true;
        },
        closeView(){
            const that= this;

            that.dialog = false;
            that.getBookmark();
        },
        filterByDepartment(){
            const that = this;
            that.tableloading = true;
            if(that.departmentfilter != "All"){
              
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getApplicationsByCriteria&data={"type": "academicDepartment", "term": "'+that.departmentfilter+'"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.flaggingList = json.flags;
                        that.modifyData(json.data);
                        that.setSnackbar("Filtering applications successful!", "#388E3C"); //green
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                    that.tableloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.tableloading = false;
                })
            }else {
                that.getApplicationList();
            }
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.getBookmark();
    }
}
</script>